import { render } from "./PraxisgruppeBenutzerListe.vue?vue&type=template&id=3d23428c&ts=true"
import script from "./PraxisgruppeBenutzerListe.vue?vue&type=script&lang=ts"
export * from "./PraxisgruppeBenutzerListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__